var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    ref: "chartdiv",
    staticStyle: { width: "100%", height: "200px" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }